import { ApiResponse, CreatePrescriptionRequest, Prescription, PrescriptionDetail } from '../../types';
import apiClient from '../api/client';

interface PrescriptionListResponse {
  success: boolean;
  data: Prescription[];
  meta: {
    page: number;
    pageSize: number;
    count: number;
    next: string | null;
    previous: string | null;
  };
}

export const prescriptionService = {
  getList: async (filters?: {
    code?: string;
    patientName?: string;
    doctorName?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }): Promise<PrescriptionListResponse> => {
    const params: Record<string, any> = {};
    
    if (filters?.code) {
      params.code = filters.code;
    }
    if (filters?.patientName) {
      params.patient_name = filters.patientName;
    }
    if (filters?.doctorName) {
      params.doctor_name = filters.doctorName;
    }
    if (filters?.startDate) {
      params.start_date = filters.startDate;
    }
    if (filters?.endDate) {
      params.end_date = filters.endDate;
    }
    if (filters?.page) {
      params.page = filters.page;
    }
    if (filters?.pageSize) {
      params.page_size = filters.pageSize;
    }

    const response = await apiClient.get<PrescriptionListResponse>('/prescriptions/', { params });
    return response.data;
  },

  getDetail: async (id: number): Promise<ApiResponse<PrescriptionDetail>> => {
    const response = await apiClient.get<ApiResponse<PrescriptionDetail>>(`/prescriptions/${id}/`);
    return response.data;
  },

  syncNational: async (pk: number): Promise<void> => {
    await apiClient.post(`/prescriptions/${pk}/sync-national/`);
  },

  syncNationalBulk: async (): Promise<void> => {
    await apiClient.post('/prescriptions/sync-national/');
  },

  exportInvoice: async (pk: number): Promise<void> => {
    await apiClient.post(`/prescriptions/${pk}/export-invoice/`);
  },

  exportInvoiceBulk: async (): Promise<void> => {
    await apiClient.post('/prescriptions/export-invoice/');
  },

  getNationalPrescriptions: async (filters?: {
    code?: string;
    patientName?: string;
    doctorName?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }): Promise<PrescriptionListResponse> => {
    const params: Record<string, any> = {
      dtqg_status: 'sent',
    };
    
    if (filters?.code) {
      params.code = filters.code;
    }
    if (filters?.patientName) {
      params.patient_name = filters.patientName;
    }
    if (filters?.doctorName) {
      params.doctor_name = filters.doctorName;
    }
    if (filters?.startDate) {
      params.start_date = filters.startDate;
    }
    if (filters?.endDate) {
      params.end_date = filters.endDate;
    }
    if (filters?.page) {
      params.page = filters.page;
    }
    if (filters?.pageSize) {
      params.page_size = filters.pageSize;
    }

    const response = await apiClient.get<PrescriptionListResponse>('/prescriptions/', { params });
    return response.data;
  },

  create: async (data: CreatePrescriptionRequest): Promise<ApiResponse<Prescription>> => {
    const response = await apiClient.post<ApiResponse<Prescription>>('/prescriptions/', data);
    return response.data;
  },

  importExcel: async (file: File): Promise<ApiResponse<{ imported: number; errors: any[] }>> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.postForm<ApiResponse<{ imported: number; errors: any[] }>>(
      '/prescriptions/import-excel/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  downloadSamplePrescription: async (): Promise<Blob> => {
    const response = await apiClient.get('/documents/template-prescription/', {
      responseType: 'blob',
    });
    return response.data;
  },
};

